<span [ngClass]="{'top': hasUnderline}" [ngStyle]="text.style">
  @if (text.type === 'TEXT') {
    <span>{{text.text}}</span>
  }
  @if (text.type === 'LINK') {
    <span>
      <a [href]="text.data.url" [target]="text.data.target" (click)="handleClick($event)">{{text.text}}</a>
    </span>
  }
</span>
